// extracted by mini-css-extract-plugin
module.exports = {"cropContainer":"CropModal-module_cropContainer_6b2e9","cropSelection":"CropModal-module_cropSelection_31659"};